import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Subjects from './Subjects'
import Ways from './Ways'
import Types from './Types'
import Categories from './Categories'
import Cards from './Cards'
import Pagination from 'components/Common/Pagination'
import styles from './index.css'

@observer(['cardTableStore'])
export default class Main extends Component {
  handleChangePage (to) {
    const { examinationId, cardTableStore } = this.props

    if (cardTableStore.currentWay.id === 3) {
      cardTableStore.changePage(to, {
        examinationId,
        subjectId: cardTableStore.currentSubject.id,
        textbookId: cardTableStore.currentCategory.id,
        page: to
      })
    } else {
      cardTableStore.changePage(to, {
        examinationId,
        subjectId: cardTableStore.currentSubject.id,
        questionTypeId: cardTableStore.currentWay.id,
        typeId: cardTableStore.types.length ? cardTableStore.currentType.id : null,
        page: to
      })
    }
  }

  render () {
    const { examinationId, cardTableStore } = this.props

    return (
      <div className={ styles.root }>
        <Subjects examinationId={ examinationId } />
        <Ways examinationId={ examinationId } />
        <Types examinationId={ examinationId } />
        <Categories examinationId={ examinationId } />
        <Cards examinationId={ examinationId } />
        <Pagination
          total={ cardTableStore.totalPage }
          current={ cardTableStore.currentPage }
          onChange={ to => this.handleChangePage(to) } />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Main/index.js
 **/